<template>
  <Icon
    aria-live="polite"
    role="status"
    name="app:spinner"
    aria-hidden="false"
    aria-label="Chargement"
  />
</template>
